export * from '@fhs/routing/src/routes/auth/index';
export { default } from '@fhs/routing/src/routes/auth/index';
